import { render, staticRenderFns } from "./ImportChoiceTypeStep.vue?vue&type=template&id=22b07e5e&scoped=true&"
import script from "./ImportChoiceTypeStep.vue?vue&type=script&lang=js&"
export * from "./ImportChoiceTypeStep.vue?vue&type=script&lang=js&"
import style0 from "./ImportChoiceTypeStep.vue?vue&type=style&index=0&id=22b07e5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b07e5e",
  null
  
)

export default component.exports